import { Avatar } from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

export const AvatarOverlayExample = {
    title: 'Avatar.Overlay',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'src',
            label: 'src',
            type: 'text',
            tsType: 'string',
            default: 'https://sun9-21.userapi.com/1N-rJz6-7hoTDW7MhpWe19e_R_TdGV6Wu5ZC0A/67o6-apnAks.jpg',
        },
    ],

    Preview({ props }){
        return (
            <Avatar.Container overlay={<Avatar.Overlay><PlaceholderIcon /></Avatar.Overlay>}>
                <Avatar.Image src={props.src} style={{objectFit:"cover"}} />
            </Avatar.Container>
        )
    },

    getCode(props){
        return `<Avatar.Container overlay={<Avatar.Overlay><PlaceholderIcon /></Avatar.Overlay>}>
  <Avatar.Image src="${props.src}" />
</Avatar.Container>`
    }

}